{ /* Generated by Copilot- Start - 2026-03-26 19:42:15 */ }
import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "../../../video-lab/dtv-text";
import DtvButton from "@directv-digital/dds.ui.dtv-button";
import CardMedia from "@mui/material/CardMedia";
import DtvTheme from "@directv-digital/dds.ui.dtv-theme";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const bps = DtvTheme.breakpoints;

export interface MyFreeDtvBannerProps {
  myfreeDtvLogo?: string;
  myfreeDtvLogoAltText?: string;
  bannerContent?: string;
  cta?: {
    label: string;
    ctaUrl: string;
    ctaAccessibility?: string;
  };
}

/**
 * MyFreeDtvBanner
 *
 * Promo card shown at the bottom of the MyFree DIRECTV modal.
 * Displays the MyFree logo, a short description, and an optional CTA button.
 */
const MyFreeDtvBanner: React.FC<MyFreeDtvBannerProps> = ({
  myfreeDtvLogo,
  myfreeDtvLogoAltText,
  bannerContent,
  cta
}) => (
    <DtvBox
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 19px",
        borderRadius: "4px",
        backgroundColor: "#EEF9FF",
        width: {
 xs: "100%",
sm: "400px"
},
        height: {
 xs: "96px",
sm: "96px",
md: "auto"
}
      }}
    >
      {/* Left: Logo + description */}
      <DtvBox sx={{
 display: "flex",
flexDirection: "column",
gap: "8px"
}}>
        {myfreeDtvLogo && (
          <CardMedia
            alt={myfreeDtvLogoAltText || "MyFree DIRECTV"}
            component="img"
            src={myfreeDtvLogo}
            sx={{
 height: "27px",
width: "97px"
}}
            onError={e => {
              if (e.currentTarget.parentElement) {
                e.currentTarget.parentElement.style.display = "none";
              }
            }}
          />
        )}
        <DtvBox
          sx={{
            display: "flex",
            // [bps.up(bps.values.sm)]: { width: "241px" },
            // [bps.down(bps.values.sm)]: { width: "153px", height: "38px" },
            width: {
 xs: "153px",
sm: "241px"
},
            height: {
 xs: "38px",
sm: "auto"
}
          }}
        >
          <DtvText
            content={bannerContent || "Stream over 130+ channels for free!"}
            sx={{
              fontSize: "14px !important",
              lineHeight: "18.2px",
              color: "#000000",
              fontWeight: 400
            }}
          />
        </DtvBox>
      </DtvBox>

      {/* Right: CTA button */}
      <DtvBox sx={{
 display: "flex",
alignItems: "center"
}}>
        {cta && (
          <DtvButton
            ariaLabel={cta.ctaAccessibility || cta.label}
            color="secondary"
            label={cta.label}
            mode="dark"
            targeturl={cta.ctaUrl}
            variant="uxsecondary"
            sx={{
              display: "flex",
              height: "36px",
              padding: "0px 16px",
              fontSize: "14px !important",
              lineHeight: "18.2px",
              fontWeight: 500
            }}
          />
        )}
      </DtvBox>
    </DtvBox>
);

export default React.memo(MyFreeDtvBanner);
{ /* Generated by Copilot- End - 2026-03-26 19:42:15 */ }
